export default __webpack_public_path__ + "static/media/mauquenchy10.fc467ee7.jpg";